export default defineNuxtRouteMiddleware((to) => {
  if (!to.query.ts) return 
  
    const tsValue = to.query.ts
    
    const newQuery = { ...to.query }
    delete newQuery.ts
    
    return navigateTo({
      path: to.path,
      query: newQuery,
      hash: `#${tsValue}`
    }, {
      redirectCode: 301,
      replace: true
    })
})